<template>
    <div>
        <slglrs-base-header-sec title="Службени гласник РС Међународни уговори" slug="MUTG"></slglrs-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <div class="table-responsive-sm">
                    <table class="table table-striped">
                        <tr>
                            <th class="text-center">БРОЈ</th>
                            <th class="text-center">ГЛАСИЛО</th>
                            <th class="text-center">ДАТУМ</th>
                            <th class="text-center">HTML</th>
                            <th class="text-center">PDF</th>
                            <th class="text-center">ВЕЛИЧИНА</th>
                        </tr>

                        <tbody>
                            <tr v-for="(item, index) in searchResult" v-bind:key="index">
                                <td class="text-center">{{ item.numStr }}</td>
                                <td class="text-center">{{ item.issueTypeShortDescription }}</td>
                                <td class="text-center">{{ item.publishDateStr }}</td>
                                <td class="text-center">
                                    <router-link class="table-html-link" :to="'/slglrsMUTG-overview/' + item.id">
                                        HTML
                                    </router-link>
                                    <!--                                <a class="table-html-link"-->
                                    <!--                                   :href="baseApiUrl + 'slglrs/MUTG/overview?numberId=' + item.id"-->
                                    <!--                                   target="_blank">HTML</a>-->
                                </td>
                                <td class="text-center">
                                    <!--                                http://10.10.30.99:8080/SlGlasnikPortal/api/slglrs/pdf?id=22326-->
                                    <!--                                :href="baseApiUrl+'api/slglrs/pdf?id='+item.id"-->
                                    <router-link v-if="canOpen === 'can_open'" :to="'slglrsViewPdf/' + item.id"
                                        class="table-pdf-link" target="_blank">
                                        PDF</router-link>
                                    <a class="table-pdf-link" v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal
                                        href="#" @click.stop.prevent>
                                        PDF
                                    </a>
                                    <a class="table-pdf-link" v-if="canOpen === 'role_not_allowed'" href="#"
                                        @click.stop.prevent="role_not_allowed()">
                                        PDF
                                    </a>
                                    <!--                                <a class="table-pdf-link"-->
                                    <!--                                   :href="'http://pravno-informacioni-sistem.rs/SlGlasnikPortal/'+'api/slglrs/pdf?id='+item.id"-->
                                    <!--                                   target="_blank">PDF</a>-->
                                </td>
                                <td class="text-center">{{ item.pdfDocumetSizeKB }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import SlglrsBaseHeaderSec from '@/base_pages/slglrs/SlglrsBaseHeaderSec.vue';
import { mapState } from 'vuex';


export default {
    name: "SlglrsMUTG_AllIssuesPage",
    components: {
        SlglrsBaseHeaderSec,
    },
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            itemList: [],
            baseApiUrl: window.env.VUE_APP_API_SLGL_DEV,

            searchResult: [],
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('MUTG')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseApiUrl + 'Prins/GetAllPrinsNumbers/MUTG')
                .then(response => {
                    this.searchResult = response.data;
                })
        },
    },
    created() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_slglrs';
    }
}
</script>

<style scoped></style>
